import TaskType from '../Models/TaskType';
import DataGridRequest from './DataGridRequest';
export class CustomPropertiesRequest extends DataGridRequest<TaskType> {
    Url = '/settings/custom_properties/api';
}
